import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import { propNumber, propShape } from '../../../helpers/custom-prop-types';
import { getFormValue } from '../../../helpers/form';
import { viewPrice } from '../../../helpers/solution';
import { validateNumber } from '../../../validate/common';
import { validateReason } from '../../../validate/professional_my_page';
import PlainInputComponent from '../Common/PlainInputComponent';
import { Checkbox } from '../FormFields';
const FinalPriceFields = ({ form, solutionPrice }) => {
    const isChangingPriceConfirmed = getFormValue(form, 'confirmToChangePrice') === true;
    const isPriceChanged = isChangingPriceConfirmed &&
        getFormValue(form, 'finalPrice') !== solutionPrice;
    return (_jsxs("div", Object.assign({ className: 'form form-narrow' }, { children: [_jsx("h3", { children: "\u6700\u7D42\u53D7\u6CE8\u91D1\u984D" }), _jsx(Field, { className: 'input-form-text is-onethird mr05', component: PlainInputComponent, name: 'finalPrice', placeholder: viewPrice(solutionPrice).toString(), props: { afterPrefix: '万円' }, validate: validateNumber }), _jsxs("div", Object.assign({ className: 'change-money' }, { children: [_jsx(Link, Object.assign({ className: 'link-text font-size-0-8rem', target: '_blank', to: '/faq' }, { children: "\u91D1\u984D\u306E\u865A\u507D\u3001\u76F4\u63A5\u53D6\u5F15\u304C\u767A\u899A\u3057\u305F\u5834\u5408" })), _jsx(Checkbox, { name: 'confirmToChangePrice', option: { label: '当初の金額から変更', value: 1 } }), _jsx("br", {}), _jsx(Field, { className: 'input-form-text check-asign-submit', component: PlainInputComponent, name: 'changePriceReason', placeholder: '変更理由を記入してください', props: { disabled: !isChangingPriceConfirmed }, validate: isPriceChanged ? validateReason : null })] }))] })));
};
FinalPriceFields.propTypes = {
    form: propShape(),
    solutionPrice: propNumber(),
};
FinalPriceFields.defaultProps = {
    form: {},
    solutionPrice: 0,
};
export default FinalPriceFields;
